import React from 'react';
import { arrayOf, bool, func, node, object, string } from 'prop-types';

import { FieldCheckbox } from '../../../components';

import FilterPlain from '../FilterPlain/FilterPlain';
import PopupOpenerButton from '../PopupOpenerButton/PopupOpenerButton';

import css from './DiscountFilter.module.css';

// Único valor que el filtro escribe en la URL (`discount=true`); apagado = param ausente.
const DISCOUNT_ON = 'true';

/**
 * Filtro "Con descuento". Es un interruptor, no una lista de opciones, así que en la fila de
 * escritorio se pinta como un chip que no abre ningún popup.
 *
 * En el modal de móvil, en cambio, se pinta como el resto de filtros (cabecera + casilla dentro
 * de `FilterPlain`): así fluye como un bloque más de la lista, en vez de flotar como una píldora
 * suelta que además el botón fijo de "Mostrar N artículos" puede tapar.
 */
const DiscountFilter = props => {
  const {
    id,
    name,
    label,
    groupLabel,
    queryParamNames,
    initialValues,
    onSubmit,
    showAsPopup,
  } = props;
  const queryParamName = queryParamNames[0];
  const isSelected = initialValues?.[queryParamName] === DISCOUNT_ON;

  if (showAsPopup) {
    // `null` (y no '' o 'false') porque `stringify` elimina los params nulos de la URL.
    return (
      <PopupOpenerButton
        isSelected={isSelected}
        toggleOpen={() => onSubmit({ [queryParamName]: isSelected ? null : DISCOUNT_ON })}
      >
        {label}
      </PopupOpenerButton>
    );
  }

  // FilterPlain habla en valores de formulario: una casilla con `value` llega como array.
  const handleSubmit = values => {
    const selected = values?.[name] || [];
    onSubmit({ [queryParamName]: selected.includes(DISCOUNT_ON) ? DISCOUNT_ON : null });
  };

  return (
    <FilterPlain
      id={`${id}.plain`}
      label={groupLabel}
      isSelected={isSelected}
      onSubmit={handleSubmit}
      initialValues={{ [name]: isSelected ? [DISCOUNT_ON] : [] }}
    >
      <fieldset className={css.fieldGroupPlain}>
        <FieldCheckbox id={`${id}-checkbox`} name={name} label={label} value={DISCOUNT_ON} />
      </fieldset>
    </FilterPlain>
  );
};

DiscountFilter.defaultProps = {
  initialValues: null,
  showAsPopup: false,
};

DiscountFilter.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  label: node.isRequired,
  groupLabel: node.isRequired,
  queryParamNames: arrayOf(string).isRequired,
  initialValues: object,
  onSubmit: func.isRequired,
  showAsPopup: bool,
};

export default DiscountFilter;
